export default __webpack_public_path__ + "static/media/img6.85543ed8.png";